import React from "react"
import { GatsbyImage } from "gatsby-plugin-image" 
class Video extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover:false
    };
  } 
  componentDidMount() {
    if(window.innerWidth < 768) {
      this.setState({ isMobile: true });
      setTimeout(function(){ document.querySelector('.image--scaled').classList.remove('is-scaled');}, 1250);  
    } else {
      this.setState({ isMobile: false });
    }
  }
  render() {
    const Video = ({children}) => {
      if(!this.props.volume){
        return (
          <video className="bg-video" muted autoPlay loop> 
          {children}
          </video>
        ) 
      }else{
        return (
          <video className="bg-video" loop>
              {children}
              <track kind="captions" />
          </video>
        )
      }
    }
    if(this.state.isMobile && this.props.mobileVideo !== 'true') {
      return ( 
        <GatsbyImage image={this.props.image} alt="Hero Image" className="bg-image image--scaled is-scaled" /> 
      )
    } else {
      return ( 
        <Video>
          <source src={this.props.video} type="video/mp4" /> 
        </Video>
      )
    }
  }
}

export default Video
